module.exports = __webpack_public_path__ + "black_shipzone.png?fa87ecbeb83a0239f44009b089a17c80";


//////////////////
// WEBPACK FOOTER
// ./assets/images/black_shipzone.png
// module id = 12
// module chunks = 0